var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from "@ember/object";
import Service from "@ember/service";
import { tracked } from "@glimmer/tracking";
import { ChartOptions, TimeScaleOptions } from "chart.js";
import dayjs from "dayjs";
let DashboardService = (_class = class DashboardService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "timeframe", _descriptor, this);
    _initializerDefineProperty(this, "endDate", _descriptor2, this);
  }
  addOneMonthToDate() {
    this.endDate = dayjs(this.endDate).add(6, "weeks").toDate();
  }
  substractOneMonthToDate() {
    this.endDate = dayjs(this.endDate).subtract(6, "weeks").toDate();
  }
  resetTime() {
    this.endDate = this.today;
  }
  get timeframeStartDate() {
    const date = new Date(this.endDate);
    let weeksAgo;
    if (this.timeframe === "month") weeksAgo = 6;else if (this.timeframe === "trimester") weeksAgo = 14;else if (this.timeframe === "year") weeksAgo = 52; // 1 year == 52 weeks

    // Go back X weeks ago
    date.setDate(date.getDate() - weeksAgo * 7);

    // Go back at the start of the month if we are using the "year" timeframe
    if (this.timeframe === "year") date.setDate(1);
    return date;
  }

  // Return the end date, at the end of the day
  get timeframeEndDate() {
    return dayjs(this.endDate).endOf("day")?.toDate();
  }
  get scaleXTimeUnit() {
    switch (this.timeframe) {
      case "month":
        return "day";
      case "trimester":
        return "week";
      case "year":
      default:
        return "month";
    }
  }
  get today() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  }
  get chartOptions() {
    return {
      clip: false,
      // See https://github.com/chartjs/Chart.js/issues/9372
      scales: {
        x: {
          type: "time",
          grid: {
            display: false
          },
          time: {
            displayFormats: {
              week: "DD MMM",
              month: "MMM YY",
              day: "DD MMM"
            },
            unit: this.scaleXTimeUnit
          },
          min: +this.timeframeStartDate,
          max: +this.timeframeEndDate,
          ticks: {
            maxTicksLimit: 8
          }
        },
        y: {
          display: false
        }
      },
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          enabled: false
        }
      },
      layout: {
        padding: {
          top: 4,
          bottom: 4
        }
      }
    };
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "timeframe", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "trimester";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "endDate", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.today;
  }
}), _applyDecoratedDescriptor(_class.prototype, "addOneMonthToDate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addOneMonthToDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "substractOneMonthToDate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "substractOneMonthToDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetTime", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resetTime"), _class.prototype), _class);
export { DashboardService as default };